(function ( $ ) {
    $.fn.newsletterForm = function() {
        var that = this;

        function submitForm() {
            var data = new FormData(that[0]);
            data.append('action', 'news_submit');

            $.ajax({
                url: ajaxurl,
                data: data,
                processData: false,
                contentType: false,
                type: 'POST',
                success:function(data){
                    var message = data.message;
                    that.find('button[type="submit"]').prop('disabled', 'disabled');
                    that.css({
                        'pointer-events': 'none',
                        'filter': 'blur(1px)',
                        'opacity': '0.2'
                    });
                    that.find('input').blur();
                    that.addClass('is-valid');
                    $('.js-newsletter-error').hide();
                    $('.js-newsletter-message')
                        .html(message)
                        .fadeIn();
                },
                error: function(xhr, status, error) {
                    // console.log(xhr.responseJSON);
                    var error = xhr.responseJSON.email;

                    that.find('button[type="submit"]').prop('disabled', false);
                    that.addClass('has-error');

                    $('.js-newsletter-error')
                        .html(error)
                        .fadeIn();
                }
            });
        }

        return this.submit(function(e){
            e.preventDefault();
            submitForm();
        });
    }
}( jQuery ));

$(function() {
    if ($('#js-newsletter').length) {
        $('#js-newsletter').newsletterForm();
    }
});
